import { useRef } from 'react';

/**
 * Создание постоянного экземпляра некоторого класса внутри компонента.
 * @param constr конструктор
 * @param ...args аргументы, в конструктор переданные
 * @returns экземпляр
 */
export const useInstance = <C extends new (...args: never[]) => {}>(
    constr: C,
    ...args: ConstructorParameters<C>
): InstanceType<C> => {
    const ref = useRef<InstanceType<C>>();

    return (ref.current = ref.current ?? (new constr(...args) as InstanceType<C>));
};
